
import React from 'react';
import { motion } from 'framer-motion';
import JobsPageCustomizer from '../components/JobsPageCustomizer';

const JobsEmbedded = () => {
  return (
    <div className="min-h-screen">
      <JobsPageCustomizer />
      
      {/* Full-screen iframe with minimal wrapper */}
      <div className="relative w-full" style={{ height: 'calc(100vh - 64px)' }}>
        <iframe
          src="https://jobs.trbe.ai/careers/trbe"
          className="w-full h-full border-0"
          title="Trbe Careers"
          allow="clipboard-read; clipboard-write"
        />
        
        {/* Loading overlay */}
        <motion.div
          initial={{ opacity: 1 }}
          animate={{ opacity: 0 }}
          transition={{ delay: 1, duration: 0.5 }}
          className="absolute inset-0 bg-white flex items-center justify-center pointer-events-none"
        >
          <div className="text-center">
            <div className="w-12 h-12 border-4 border-brand-orange border-t-transparent rounded-full animate-spin mx-auto mb-4"></div>
            <p className="text-brand-purple font-medium">Loading job opportunities...</p>
          </div>
        </motion.div>
      </div>
    </div>
  );
};

export default JobsEmbedded;
